/**
 * @description
 * Default options to be passed to the router
 */
export const defaultRouterOptions = {
    /**
     * @description
     * Default encoding function to use, this is the encodeUriComponent function by default
     *
     * @param decodedValue value to be encoded
     * @returns encoded value
     */
    parameterValueEncoder: (decodedValue) => encodeURIComponent(decodedValue),
    /**
     * @description
     * Default decoding function to use, this is the decodeURIComponent function by default
     *
     * @param encodedValue value to be decoded
     * @returns decoded value
     */
    parameterValueDecoder: (encodedValue) => decodeURIComponent(encodedValue),
    /**
     * Use `{` and `}` as a default for matching placeholders in the route templates.
     */
    parameterPlaceholderRE: /\{(.*?)\}/gu,
    /**
     * Assume a maximum parameter value length of 50
     */
    maximumParameterValueLength: 50,
};
//# sourceMappingURL=router-options.js.map